export const rulePeriodicities = ['once', 'monthly', 'quarterly', 'semiannual', 'annual'];
export const isFixedRule = (v) => typeof v === 'object' &&
    v !== null &&
    typeof v.id === 'string' &&
    typeof v.code === 'string' &&
    typeof v.lineageId === 'string' &&
    Number.isInteger(v.versionNumber) &&
    typeof v.isCurrent === 'boolean' &&
    (v.deletedAt === null ||
        typeof v.deletedAt === 'string') &&
    (v.lifecycleReason === null ||
        typeof v.lifecycleReason === 'string') &&
    typeof v.amount === 'string' &&
    rulePeriodicities.includes(v.periodicity);
export const isFixedRulesResponse = (v) => typeof v === 'object' &&
    v !== null &&
    Array.isArray(v.items) &&
    v.items.every(isFixedRule);
export const isFixedRuleResponse = (v) => typeof v === 'object' && v !== null && isFixedRule(v.rule);
export const isFixedRuleVersionsResponse = isFixedRulesResponse;
